import React from 'react';
import { AiOutlineMail, AiFillInstagram } from 'react-icons/ai'; // Importing the required icons

export default function Footer() {
    return (
        <footer className="py-6 px-8 bg-white">
            <div className="flex flex-col md:flex-row justify-between items-center">
                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 space-x-0 md:space-x-4">
                    <a href="mailto:studio@schediopartners.com" className="flex items-center space-x-2 text-gray-600 hover:text-gray-900">
                        <AiOutlineMail size={20} />
                        <p>email</p>
                    </a>
                    <a href="https://www.instagram.com/schedio_partners/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-gray-600 hover:text-gray-900">
                        <AiFillInstagram size={20} />
                        <p>instagram</p>
                    </a>
                </div>
                <p className="mt-4 md:mt-0 text-gold-500">© 2023 Schedio</p>
            </div>
        </footer>
    );
}
